// src/pages/seller/productStatus/StatusPage.tsx
import React from 'react';

interface Product {
  id: string; // 고유 식별자 추가
  image: string | null;
  category: string;
  name: string;
  price: number;
  status: string;
}

interface StatusPageProps {
  status: string;
  products: Product[];
}

const StatusPage: React.FC<StatusPageProps> = ({ status, products }) => {
  return (
    <div className="overflow-x-auto">
      <table className="min-w-full table-auto border-collapse">
        <thead className="border-b bg-gray-100">
          <tr>
            <th scope="col" className="px-4 py-2 w-48 text-center">
              이미지
            </th>
            <th scope="col" className="px-4 py-2 w-36 text-left">
              카테고리
            </th>
            <th scope="col" className="px-4 py-2 w-48 text-left">
              상품명
            </th>
            <th scope="col" className="px-4 py-2 w-48 text-center">
              가격
            </th>
            <th scope="col" className="px-4 py-2 w-48 text-center">
              상태
            </th>
          </tr>
        </thead>
        <tbody>
          {products.map((product) => (
            <tr key={product.id} className="border-b hover:bg-gray-50">
              <td className="px-4 py-2 flex justify-center items-center">
                {product.image ? (
                  <img
                    src={product.image}
                    alt={product.name}
                    className="w-20 h-20 object-cover rounded"
                  />
                ) : (
                  <span className="text-gray-500">이미지 없음</span>
                )}
              </td>
              <td className="px-4 py-2">{product.category}</td>
              <td className="px-4 py-2 text-ellipsis overflow-hidden whitespace-nowrap">
                {product.name}
              </td>
              <td className="px-4 py-2 text-center">
                {product.price.toLocaleString()} 원
              </td>
              <td className="px-4 py-2 text-center">
                <span
                  className={`px-2 py-1 rounded ${
                    product.status === '판매중'
                      ? 'bg-green-100 text-green-800'
                      : product.status === '판매중지'
                      ? 'bg-red-100 text-red-800'
                      : 'bg-gray-100 text-gray-800'
                  }`}
                >
                  {product.status}
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default StatusPage;
